<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ap_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ap_kind">
            <label class="weui-form-preview__label">{{customLabel.ap_kind || "让利形式"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ap_kind }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ap_agentname">
            <label class="weui-form-preview__label">{{customLabel.ap_agentname || "代理商"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ap_agentname }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_proddesc">
            <label class="weui-form-preview__label">{{customLabel.cu_proddesc || "代理产品种类"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.cu_proddesc }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ap_currency">
            <label class="weui-form-preview__label">{{customLabel.ap_currency || "币种"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ap_currency }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ap_taxrate">
            <label class="weui-form-preview__label">{{customLabel.ap_taxrate || "税率%"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ap_taxrate }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ap_startdate">
            <label class="weui-form-preview__label">{{customLabel.ap_startdate || "生效日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'"
              >{{ form.main.ap_startdate }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ap_enddate">
            <label class="weui-form-preview__label">{{customLabel.ap_enddate || "失效日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'"
              >{{ form.main.ap_enddate }}
              </span>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview" >
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ap_remark">
            <label class="weui-form-preview__label">{{customLabel.ap_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ap_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="creatorName">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "录入人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "录入日期"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.createTime
            }}</span>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"          
        >
          <div class="form-detail-preview_num">{{ item.apd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{
              item.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_orispeccode" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{
              item.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="apd_qty">
            <label class="weui-form-preview__label">{{customLabel.apd_qty || "数量"}}</label>
            <span class="weui-form-preview__value">{{
              item.apd_qty
            }} {{ item.pr_unit }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_brand">
            <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
            <span class="weui-form-preview__value">{{
              item.pr_brand
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="apd_custname">
            <label class="weui-form-preview__label">{{customLabel.apd_custname || "客户"}}</label>
            <span class="weui-form-preview__value">{{
              item.apd_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="apd_saleprice">
            <label class="weui-form-preview__label">{{ form.main.ap_kind == "返点" ? "代理商价格" : "终端销售价" }}</label>
            <span class="weui-form-preview__value">{{
              item.apd_saleprice
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="apd_coefficient">
            <label class="weui-form-preview__label">{{ form.main.ap_kind == "返点" ? "返点点数%" : "折扣系数" }}</label>
            <span class="weui-form-preview__value">{{
               numberFormat(item.apd_coefficient,'##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="apd_specialprice">
            <label class="weui-form-preview__label">{{customLabel.apd_specialprice || "特价"}}</label>
            <span class="weui-form-preview__value">{{
              item.apd_specialprice
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="apd_price">
            <label class="weui-form-preview__label">{{customLabel.apd_price || "价格"}}</label>
            <span class="weui-form-preview__value">{{
              item.apd_price
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="apd_status">
            <label class="weui-form-preview__label">{{customLabel.apd_status || "是否有效"}}</label>
            <span class="weui-form-preview__value">{{
              item.apd_status ? "是" : "否"
            }}</span>
          </div>
          </custom-layout>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/agent/price_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/agent/agentprice",
      codeField: "ap_code",
      statusField: "ap_statuscode",
      caller: "AgentPrice",
      xtype:'agent-agentprice-formpanel'
    };
  }
}
</script>